import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import ErrorToast from '../ErrorToast';
import WarningToast from '../WarningToast';
import SuccessToast from '../SuccessToast';
import axios from '../../API/axios';
import dayjs from 'dayjs';
import Flatpickr from 'react-flatpickr'
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useTranslation } from 'react-i18next';


const HiringStatus = ({ item }) => {
    const { t } = useTranslation();
          const language = localStorage.getItem("Lang");

    const list = [
        { value: 'Declined', label: t("Job Application.Declined"), isDisabled: true },
        { value: 'Shortlisted', label: t("Job Application.Shortlisted"), isDisabled: true },
        { value: 'Scheduled', label: t("Job Application.Scheduled") },
        { value: 'Hired', label: t("Job Application.Hired") },
        { value: 'Rejected', label: t("Job Application.Rejected") },
        { value: 'Blocked', label: t("Job Application.Blocked") },
    ];

    const InterviewPlaceType = [
        { value: '1', label: t("SearchJob.OnSite") },
        { value: '2', label: t("SearchJob.Remotely") },
        { value: '3', label: t("SignIn.others") },
    ]

    const [statusModal, setStatusModal] = useState(false);
    const [scheduleModal, setScheduleModal] = useState(false);
    const [currentJobId, setCurrentJobId] = useState(null);
    const [currentHiringStatus, setCurrentHiringStatus] = useState(null);
    const [remark, setRemark] = useState("");
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);
    const [errorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);
    const [hiringStatus, setHiringStatus] = useState(item.hiringStatusName);

    const sessionId = localStorage.getItem("sessionId");



    const handleStatusModal = (jobId = null, hiringStatus = null) => {
        setCurrentJobId(jobId);
        setCurrentHiringStatus(hiringStatus);
        setStatusModal(!statusModal);
    };

    const handleSubmit = () => {
        if (currentJobId && currentHiringStatus) {
            HiringStatus(currentJobId, currentHiringStatus);
        }
        setStatusModal(false);
    };

    const HiringStatus = (jobId, hiringStatus) => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            jbApplctnId: jobId,
            hiringStatus: hiringStatus,
            remark: remark,
        };
        console.log(data);
        axios
            .post(`JobApplication/UpdateHiringStatus`, data)
            .then((response) => {
                const res = response.data.responseData;
                setToastMessage(response.data.message);
                setShowToast(true);
                setRemark('')
            })
            .catch((e) => {
                console.log(e);
                if (e.response && e.response.status === 404) {
                    setWarningToastMessage(e.response.data.message);
                    setShowWarningToast(true);
                } else {
                    setErrorToastMessage(e.response.data.message);
                    setShowErrorToast(true);
                }
            });
    };


    const [startDate, setStartDate] = useState(null);
    const [interviewPT, setInterviewPT] = useState("");
    const [placeDetail, setPlaceDetail] = useState("");

    const handleScheduleModal = (jobId = null) => {
        setCurrentJobId(jobId);
        setScheduleModal(!scheduleModal);
    };

    const handleSubmitSechdule = () => {
        if (currentJobId) {
            Schedule(currentJobId);

        }
    };


    const Schedule = (jobId) => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            jbApplctnId: jobId,
            scheduleTime: startDate === "" ? "" : dayjs(startDate).format("YYYY-MM-DDTHH:mm:ss"),
            placeType: interviewPT,
            placeDetails: placeDetail,
            remark: remark,
            langKey: language === "en" ? "" : language,

        };
        console.log(data);
        if (startDate === "" || interviewPT === "") {
            setWarningToastMessage(t("modals.Please fill all the required fields"));
            setShowWarningToast(true)
        } else {
            axios
                .post(`JobApplication/ScheduleInterview`, data)
                .then((response) => {
                    const res = response.data.responseData;
                    setToastMessage(response.data.message);
                    setShowToast(true);
                    setRemark('')
                    setStartDate(null)
                    setInterviewPT('')
                    setPlaceDetail('')
                    setScheduleModal(false);
                })
                .catch((e) => {
                    console.log(e);
                    if (e.response && e.response.status === 404) {
                        setWarningToastMessage(e.response.data.message);
                        setShowWarningToast(true);
                    } else {
                        setErrorToastMessage(e.response.data.message);
                        setShowErrorToast(true);
                    }
                });
        }
    };

    useEffect(() => {
        if (statusModal || scheduleModal) {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
            document.body.classList.add('modal-open'); // When a modal opens
        } else {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = '';
            document.body.classList.remove('modal-open'); // When a modal closes
        }
    }, [statusModal, scheduleModal]);

    const preventYearScroll = (datePickerInstance) => {
        const yearElement = datePickerInstance.currentYearElement;
        if (yearElement) {
            yearElement.addEventListener("wheel", (e) => {
                e.preventDefault(); // Stops mouse scroll
            });
        }
    };
    useEffect(() => {
        setHiringStatus(item?.hiringStatusName)
    }, [item])

    return (
        <>
            {/* {item.hiringStatus === 6 ? <p>hired</p> : <ReactSelect
                name="country"
                onChange={(e) => {
                    console.log(e?.label);
                    if (e?.label === 'Schedule') {
                        setHiringStatus(e?.label);
                        handleScheduleModal(item?.jbApplctnId);
                    } else {
                        setHiringStatus(e?.label);
                        handleStatusModal(item?.jbApplctnId, e?.label);
                    }
                }}
                value={list.find(c => c.label === hiringStatus)}
                className="react-select w-100"
                classNamePrefix="select"
                options={list}
                isClearable={true}
                menuPortalTarget={document.body}
            />} */}

            {item?.hiringStatus === 5 ? <ReactSelect
                name="country"
                onChange={(e) => {
                    console.log(e?.label);
                    if (e?.label === 'Scheduled' ) {
                        setHiringStatus(e?.label);
                        handleScheduleModal(item?.jbApplctnId);
                    } else {
                        setHiringStatus(e?.label);
                        handleStatusModal(item?.jbApplctnId, e?.label);
                    }
                }}
                value={list.find(c => c.label === hiringStatus)}
               className="react-select hiringSelect HuzhiringSelect"
                classNamePrefix="huz-hiring-portal select"
                options={list}
                // menuIsOpen={true}
                // isClearable={true}
                style={{ width: '150px!important' }}
                menuPortalTarget={document.body}
            /> : <div className='badgeContainer'>
                {item.hiringStatus === 6 ? <div className="badge badge-notification hired me-3 mb-1">
                    {item?.hiringStatusName}
                </div> : item.hiringStatus === 7 ? <div className="badge badge-notification rejected me-3 mb-1">
                    {item?.hiringStatusName}
                </div> : <div className="badge badge-notification me-3 mb-1">
                    {item?.hiringStatusName}
                </div>}

            </div>}
            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />
            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />
            <ErrorToast
                show={showErrorToast}
                message={errorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
            {statusModal && (
                <div
                    className="modal fade show postAdd"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content d-flex justify-content-around">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6>{t("modals.Update Hiring Status")}</h6>
                                {/* <span
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => handleStatusModal()}
                                >
                                    close
                                </span> */}
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => handleStatusModal()}
                                />
                            </div>
                            <div className="d-flex modalBorder pb-4 d-flex justify-content-center px-4">
                                <div className="col-md-12 mt-2 ps-0 mb-2 userInput d-flex flex-column align-items-center">
                                    <div className="col-md-12 mt-2">
                                        <label htmlFor="remark">{t("Job Application.Remark")}</label>
                                        <input
                                            type="text"
                                            style={{ width: "100%" }}
                                            value={remark}
                                            onChange={(e) => setRemark(e.target.value)}
                                            className='form-control'
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                                <button
                                    type="button"
                                    className="mainBtn1 me-4"
                                    onClick={handleSubmit}
                                >
                                    {t("User Profile.Submit")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {scheduleModal && (
                <div
                    className="modal fade show postAdd"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content d-flex justify-content-around">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6>Add Interview Schedule Details</h6>
                                {/* <span
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => handleScheduleModal()}
                                >
                                    close
                                </span> */}
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => handleScheduleModal()}

                                />
                            </div>
                            {/* <div className="d-flex modalBorder pb-4 d-flex justify-content-center"> */}
                            <div className="row settings mt-2  mb-2 userInput d-flex flex-column align-items-center px-4">
                                <div className="col-md-12 mt-2">
                                    <label htmlFor="remark">Schedule Time <span style={{ color: "red" }}>*</span></label>

                                    <Flatpickr className='form-control' value={startDate} onChange={date => setStartDate(date[0])} id='dob'
                                        options={{
                                            minDate: "today",
                                            enableTime: true, // Enables time selection
                                            time_24hr: true,  // Enables 24-hour time format, if needed
                                            dateFormat: "Y-m-d H:i", // Format: Year-Month-Day Hour:Minute
                                            minuteIncrement: 1,
                                            onReady: (selectedDates, dateStr, instance) => {
                                                preventYearScroll(instance); // Call the function to stop scroll on year
                                            },
                                            onOpen: (selectedDates, dateStr, instance) => {
                                                preventYearScroll(instance); // Also prevent scroll when the picker opens
                                            },
                                        }} />
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label htmlFor="remark">Place Type <span style={{ color: "red" }}>*</span></label>
                                    <ReactSelect
                                        name="country"
                                        onChange={(e) => {
                                            console.log(e?.label);
                                            setInterviewPT(e?.label)
                                        }}
                                        defaultValue={interviewPT}
                                        className="react-select dropdown-Input-react w-100"
                                        classNamePrefix="select"
                                        options={InterviewPlaceType}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label htmlFor="remark">Place Details</label>
                                    <input
                                        type="text"
                                        style={{ width: "100%" }}
                                        value={placeDetail}
                                        onChange={(e) => setPlaceDetail(e.target.value)}
                                        className='form-control'
                                    />
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label htmlFor="about">
                                        Remark
                                    </label>
                                    <textarea
                                        id="about"
                                        name="about"
                                        rows="2"
                                        cols="65"
                                        value={remark}
                                        onChange={(e) => setRemark(e.target.value)}
                                    ></textarea>
                                </div>
                            </div>
                            {/* </div> */}
                            <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                                <button
                                    type="button"
                                    className="mainBtn1 me-4"
                                    onClick={handleSubmitSechdule}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default HiringStatus;
